export default {
  namespaced: true,
  state: {
    CW_VALUE: 0,
    CW_VALUE_LIMIT: 0,
    CW_VALUE_ROUND_STEP: false,
    BONUS_VALUE: 0, // значение используемого бонуса, который возвращает бек
    use: 0,
  },
  mutations: {
    setUseValue(state, payload) {
      state.use = payload
    },
    setLimitValue(state, payload) {
      state.CW_VALUE_LIMIT = parseFloat(payload)
    },
  },

  getters: {
    isUseCoralWallet: (state) => !!state.use ?? false,
  },
}
